import { InterwillDto } from '@/entities/interwills';
import { FileMetaInfoDto } from '@/shared/lib/sj-orm/models/file-meta-info.dto';

import { CollectionName } from '../../constants';
import { MigratedMigrationCollectionsData, MigrationType } from '../types';

const migrate: MigrationType['migrate'] = (data) => {
  const migratedData: MigratedMigrationCollectionsData = new Map();

  const interwills = data.get(CollectionName.INTERWILLS);
  const fileMetaInfos = data.get(CollectionName.FILE_META_INFO);

  if (!fileMetaInfos) {
    return migratedData;
  }

  const pathsToMigrate = new Set<string>();

  if (interwills) {
    for (const item of interwills.values()) {
      const dto = item as InterwillDto;
      if (dto.executionState?.testatorVerification?.generatedPdfPath) {
        pathsToMigrate.add(dto.executionState.testatorVerification.generatedPdfPath);
      }
      if (dto.executionState?.witnessVerifications) {
        Object.values(dto.executionState.witnessVerifications).forEach((w) => {
          if (w?.generatedPdfPath) {
            pathsToMigrate.add(w.generatedPdfPath);
          }
        });
      }
    }
  }

  const migratedFileMetaInfos = new Map();

  for (const [key, item] of fileMetaInfos.entries()) {
    const metaInfo = item as unknown as FileMetaInfoDto;

    if (
      pathsToMigrate.has(metaInfo.filePath) ||
      metaInfo.extension === '.VIDEO VERIFICATION CERTIFICATE'
    ) {
      let name = metaInfo.name;
      let extension = metaInfo.extension;

      if (extension !== '.pdf') {
        extension = '.pdf';
      }

      if (metaInfo.createdAt) {
        const dateStr = new Date(metaInfo.createdAt).toISOString();
        name = `${name} (${dateStr})`;
      }

      migratedFileMetaInfos.set(key, { ...metaInfo, extension, name });
    } else {
      migratedFileMetaInfos.set(key, metaInfo);
    }
  }

  migratedData.set(CollectionName.FILE_META_INFO, migratedFileMetaInfos);
  return migratedData;
};

export const migration15: MigrationType = {
  migrate,
  version: 16,
};
